<template>
  <div>
    <v-card flat v-if="partnerPermission.length">
      <v-card-title>
        <h3>
          {{ $t("components.login.LoginCardAuthorizationOverview.permissions") }} {{ $t("common.nouns.partner") }}
        </h3>
      </v-card-title>
      <v-card-text>
        <template>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Permission</th>
                  <th class="text-left">Action</th>
                  <th class="text-left">Subject</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(permission, i) in partnerPermission" :key="i">
                  <td>{{ $t(`BackendResourceEnum.${permission.type}`) }} ({{ permission.type }})</td>
                  <td>
                    <v-chip v-for="action in permission.action" :key="action">
                      {{ action }}
                    </v-chip>
                  </td>
                  <td>{{ getPartnerName(permission) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-card-text>
    </v-card>

    <v-card flat v-if="fleetPermission.length">
      <v-card-title>
        <h3>{{ $t("components.login.LoginCardAuthorizationOverview.permissions") }} {{ $t("common.nouns.fleet") }}</h3>
      </v-card-title>
      <v-card-text>
        <template>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Permission</th>
                  <th class="text-left">Action</th>
                  <th class="text-left">Subject</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(permission, i) in fleetPermission" :key="i">
                  <td>{{ $t(`BackendResourceEnum.${permission.type}`) }} ({{ permission.type }})</td>
                  <td>
                    <v-chip v-for="action in permission.action" :key="action">
                      {{ action }}
                    </v-chip>
                  </td>
                  <td>{{ getFleetName(permission) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-card-text>
    </v-card>

    <v-card flat v-if="user.roles.length">
      <v-card-title>
        <h3>{{ $t("components.login.LoginCardAuthorizationOverview.roles") }}</h3>
      </v-card-title>
      <v-card-text>
        <template>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="role in user.roles" :key="role">
                  <td style="border: none">{{ role }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import {
  MrfiktivFleetPermissionDtoGen,
  MrfiktivPermissionDtoGen as PermissionDto
} from "@/services/mrfiktiv/v1/data-contracts";
import { ConfigModule } from "@/store/modules/config";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoginCardAuthorizationOverview extends Vue {
  get partnerPermission() {
    if (this.isReport) {
      return UserModule.partnerPermission.filter((p) => ReportModule.partner.id === p.id);
    }

    return UserModule.partnerPermission;
  }

  get fleetPermission() {
    if (this.isReport) {
      return UserModule.fleetPermission.filter((p) => ReportModule.partner.id === p.partnerId);
    }

    return UserModule.fleetPermission;
  }

  get user() {
    return UserModule.user;
  }

  get isReport() {
    return AppContextEnum.REPORT === ConfigModule.appContext;
  }

  getPartnerName(permission: PermissionDto): string {
    if (this.isReport) {
      return ReportModule.partner.companyName;
    }

    const partner = PartnerModule.partnersMap.get(permission.id);

    if (partner) {
      return partner?.companyName;
    }

    return permission.id;
  }

  getFleetName(permission: MrfiktivFleetPermissionDtoGen): string {
    const fleet = FleetManagerModule.fleets.find((f) => f.id === permission.fleetId);

    if (fleet) {
      return fleet?.title;
    }

    return permission.fleetId;
  }
}
</script>
